import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as SkuMetadataFeature from './sku-metadata.reducer';
import { SkuMetadataEffects } from './sku-metadata.effects';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(SkuMetadataFeature.feature.name, SkuMetadataFeature.feature.reducer),
        EffectsModule.forFeature([SkuMetadataEffects])
    ]
})
export class SharedStateSkuMetadataModule {}
